export default __webpack_public_path__ + "cf0bfae966a9e3e85c0a52c32963fa7b.png";